import React, { Fragment } from 'react';
import { Button, Col, Icon, Row, Table, Tag } from 'antd';
import InfoRow from '../../../../components/common/info-row';
import { currencyVND, dateToString } from '../../../../utils';

export default (props) => {

	const { purchaseDetail } = props;
	const refundPurchaseList = purchaseDetail.refundPurchaseResponses || [];

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			key: 'index',
			width: 60,
			render: (text, record, index) => index + 1
		},
		{
			title: 'Ngày tạo',
			dataIndex: 'createdDate',
			width: 170,
			align: 'center',
			render: (date) => dateToString(date)
		},
		{
			title: 'Số lượng hoàn',
			dataIndex: 'quantity',
			align: 'center',
			width: 150
		},
		{
			title: 'Giá trị hoàn trả',
			dataIndex: 'price',
			align: 'center',
			width: 150,
			render: (price) => currencyVND(price)
		},
		{
			title: 'Trạng thái',
			dataIndex: 'status',
			align: 'center',
			render: (value) => value === 0 ? <Tag style={{ width: '110px' }} color="#87d068">Đang giao dịch</Tag> :
				<Tag style={{ width: '110px' }} color="#87d068">Đã hoàn</Tag>
		},
		{
			title: 'Tỉ lệ hoàn tiền',
			dataIndex: 'refundStatus',
			width: 'fit-content',
			align: 'center',
			render: (refundStatus) => {
				switch (refundStatus) {
					case 1:
						return 'Đã hoàn toàn bộ';
					case 2:
						return 'Đã hoàn 1 phần';
					default:
						return 'Chưa hoàn';
				}
			}
		}
	];

	const columnsDetail = [
		{
			title: 'STT',
			dataIndex: 'index',
			key: 'index',
			width: 60,
			render: (text, record, index) => index + 1
		},
		{
			title: 'Mã sản phẩm',
			dataIndex: 'code',
			key: 'code',
			width: 100,
			align: 'center',
			render: (text, record) => {
				return <Fragment> <Button type="dashed" onClick={() => {
					window.open(`/product/${record.id}`);
				}}>{text}</Button>
				</Fragment>;
			}
		},
		{
			title: 'Tên sản phẩm',
			dataIndex: 'productName',
			key: 'productName'
		},
		{
			title: 'SL trả',
			width: 150,
			dataIndex: 'quantity',
			align: 'center'
		},
		{
			title: 'Đơn giá',
			width: 150,
			align: 'center',
			render: (record) => {
				return <b>{currencyVND(record.price)}</b>;
			}
		}
	];

	const expandedRowRenderProductRefund = (record) => {
		const { imeiList } = record;
		return <Fragment>
			<div className={'mt-20 mb-20'}>
				<i>Danh sách IMEI ({imeiList?.length || 0}): </i>{imeiList?.map((el) => <Tag color={'blue'} key={el.id}>
				{el.imei}
			</Tag>)}
			</div>
		</Fragment>;
	};

	const expandedRowsKey = (record) => {
		return record?.orderProductResponses?.filter(el => !el.isNormal).map(el => el.id) || [];
	};

	const expandedRowRender = (record) => {
		return <Fragment>
			<div>
				<Row>
					<Col>
						<b>Thông tin đơn trả hàng nhà cung cấp: </b>
					</Col>
					<Col>
						<InfoRow labelSpan={7} valueSpan={12} label={'Chi nhánh'} value={record?.branchName} />
						<InfoRow labelSpan={7} valueSpan={12} label={'Nhận hoàn tiền'} value={currencyVND(record?.price)} />
						<InfoRow labelSpan={7} valueSpan={12} label={'Lý do hoàn tiền'} value={record?.reason} />
					</Col>
				</Row>
				{/*<hr/>*/}
				<Row>
					<Table
						title={() => <b>Thông tin sản phẩm trả</b>}
						rowKey={'id'}
						bordered={true}
						dataSource={record?.orderProductResponses || []}
						columns={columnsDetail}
						rowClassName="editable-row"
						pagination={false}
						expandedRowKeys={expandedRowsKey(record)}
						expandedRowRender={expandedRowRenderProductRefund}
						expandIconAsCell={false}
						expandIcon={() => ''}
					/>
					<Col className={'mt-20'}>
						{renderFooter(record)}
					</Col>
				</Row>
			</div>
		</Fragment>;
	};

	const renderFooter = (record) => {
		return <Fragment>
			<InfoRow label={'Số lượng'} value={record?.quantity || '---'} />
			{/*<InfoRow label={'Tổng tiền'} value={currencyVND(record?.price) || '---'} />*/}
			<InfoRow label={'Chiết khấu'} value={currencyVND(record?.discount) || '---'} />
			<InfoRow label={'Tổng giá trị trả'} value={currencyVND(record?.price) || '---'} />
		</Fragment>;
	};

	return (
		<Fragment>
			<Row gutter={12}>
				<Col>
					<Table
						rowKey={'id'}
						dataSource={refundPurchaseList}
						columns={columns}
						rowClassName="editable-row"
						pagination={false}
						expandedRowRender={expandedRowRender}
						expandIcon={({ expanded, onExpand, record }) => <Icon type={expanded ? 'down-circle' : 'right-circle'}
																																	onClick={async e => {
																																		// await onBeforeExpandRow(expanded, record);
																																		onExpand(record, e);
																																	}} theme="twoTone" />}
					/>
				</Col>
			</Row>
		</Fragment>
	);
};
